import { FC } from 'react';
import Icon from '../Icon';
import { AlertStyled } from './style';
import { Props, Type } from './types';

const getIcon = (type: Type) => {
  switch (type) {
    case 'warning': {
      return <Icon.Warning />;
    }
    case 'error': {
      return <Icon.ExclamationMark />;
    }
    case 'success': {
      return <Icon.Check />;
    }
    case 'info': {
      return <Icon.Info />;
    }
    default:
      return null;
  }
};

const Alert: FC<Props & { children?: any }> = ({ id, type, show, children, ...restProps }) => {
  if (show) {
    return (
      <AlertStyled id={id} type={type} {...restProps}>
        {getIcon(type)}
        {children}
      </AlertStyled>
    );
  }

  return null;
};

export default Alert;
